const translations = {
  fr: {
    // Common
    loading: "Chargement...",
    save: "Enregistrer",
    cancel: "Annuler",
    forgot_password: "Mot de passe oublié ?",
    forgot_password_desc: "Entrez votre email pour recevoir un lien de réinitialisation.",
    send_reset_link: "Envoyer le lien",
    reset_email_sent: "Un email de réinitialisation a été envoyé si ce compte existe.",
    back_to_login: "Retour au login",
    my_information: "Mes informations",
    change_password: "Modifier le mot de passe",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    password: "Mot de passe",
    enable_notifications: "Activer les notifications",
    notifications_enabled: "Notifications activées",
    notifications_denied: "Notifications refusées par le navigateur",
    allowed_statuses: "Statuts autorisés",
    password_changed: "Mot de passe modifié avec succès",
    password_error: "Erreur lors du changement de mot de passe",
    new_product: "Nouveau produit",
    size_guide: "Guide des tailles",
    size_guide_desc: "Référence des tailles pour les produits textiles Panther.",
    size: "Taille",
    chest: "Poitrine",
    waist: "Tour de taille",
    hip: "Hanches",
    support: "Support",
    new_request: "Nouvelle demande",
    your_message: "Votre message",
    describe_issue: "Décrivez votre demande ou problème...",
    send: "Envoyer",
    my_tickets: "Mes demandes",
    no_tickets: "Aucune demande pour le moment.",
    ticket_sent: "Demande envoyée avec succès",
    open: "En attente",
    closed: "Répondu",
    admin_response: "Réponse Admin",
    respond: "Répondre",
    type_response: "Tapez votre réponse...",
    response_sent: "Réponse envoyée",
    personalization: "Personnalisation clients",
    client_selection: "Sélection du client",
    select_client: "Sélectionner un client",
    new_client: "Nouveau client",
    personalization_lines: "Lignes de personnalisation",
    name: "Nom",
    number: "Numéro",
    add_line: "Ajouter une ligne",
    validate_download: "Valider et télécharger Excel",
    fill_fields: "Veuillez sélectionner un client et remplir au moins une ligne.",
    file_downloaded: "Fichier téléchargé",
    last_name: "Nom",
    first_name: "Prénom",
    country: "Pays",
    phone: "Téléphone",
    address: "Adresse",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    close: "Fermer",
    search: "Rechercher",
    actions: "Actions",
    yes: "Oui",
    no: "Non",
    logout: "Déconnexion",
    language: "Langue",
    login: "Connexion",
    login_subtitle: "Accédez à votre espace de gestion",
    connecting: "Connexion...",
    connect: "Se connecter",
    order_management: "Gestion des commandes et du suivi",

    // Nav
    nav_dashboard: "Tableau de bord",
    nav_orders: "Commandes",
    nav_clients: "Clients",
    nav_products: "Produits",
    nav_archives: "Archives",
    nav_commercials: "Commerciaux",
    nav_partners: "Partenaires",
    nav_expenses: "Dépenses",
    nav_transport: "Transport",
    transport_orders_nav: "Commandes à livrer",
    transport_orders_title: "Commandes à livrer",
    transport_recap_nav: "Récap Transport",
    transport_recap_title: "Récap Transport",
    transport_unpaid: "En attente de paiement",
    transport_paid_archives: "Archives payées",
    no_transport_orders: "Aucune commande en livraison",
    tracking_saved: "Tracking enregistré",
    checkin_title: "Check-in",
    checkin_orders: "Commandes à traiter",
    no_checkin_orders: "Aucune commande en attente",
    print_delivery: "PRINT DELIVERY",
    number_of_boxes: "Nombre de colis",
    generate_label: "Générer l'étiquette",
    label_generated: "Étiquette générée",
    mark_shipped: "EN LIVRAISON",
    confirm_ship: "Confirmer la mise en livraison ?",
    order_shipped: "Commande en cours de livraison",
    weight_required: "Le poids est requis",
    tracking_number: "N° de suivi",
    tracking_link: "Lien de suivi",
    track_package: "Suivre le colis",
    estimated_short: "Est.",
    delivered_short: "Livré le",
    delivery_col: "Livraison",
    validate_package: "Valider le colis (irréversible)",
    package_validated: "Colis validé",
    weight_kg: "Poids (kg)",
    price_vnd: "Prix (VND)",
    weight_price_required: "Poids et prix requis",
    transport_validate_warning: "Cette action est irréversible. Le poids et le prix ne pourront plus être modifiés après validation.",
    order_name: "Commande",
    order_date_col: "Date",
    select_all: "Tout sélectionner",
    mark_as_paid: "Payer",
    payment_date: "Date paiement",
    validated: "Validé",
    country: "Pays",
    address: "Adresse",
    phone: "Téléphone",
    pieces: "Pièces",
    client: "Client",
    nav_settings: "Paramètres",

    // Dashboard
    dashboard_title: "Tableau de bord",
    dashboard_subtitle: "Vue d'ensemble de votre activité",
    fabric_alert_text: "RAPPEL COMMANDE TISSU",
    alert_dismissed: "Alerte acquittée",
    click_to_dismiss: "Cliquer pour acquitter",
    fabric_question: "Le tissu a-t-il été commandé ?",
    fabric_confirm: "OK Validé",
    all_companies: "Toutes les sociétés",
    monthly_sales: "Ventes mensuelles",
    france_vs_vn: "Panther France vs Vietnam",
    total_sales: "Ventes totales",
    total_costs: "Coûts totaux",
    gross_margin: "Marge brute",
    commissions: "Commissions",
    expenses: "Dépenses",
    net_profit: "Bénéfice net",
    pieces_sold: "Pièces vendues",
    pieces_sold_monthly: "Pièces vendues par mois",
    orders_in_progress: "Commandes en cours",
    no_orders_in_progress: "Aucune commande en cours",
    change_status: "CHANGER LE STATUT",
    delivery_office: "LIV. BUREAU",
    delivery_couture: "LIV. COUTURE",
    delivery_client: "LIV. CLIENT",
    order: "Commande",
    orders_count: "commande(s)",
    client: "Client",
    country: "Pays",
    phone: "Téléphone",
    email: "Email",
    address: "Adresse",
    company: "Société",
    pieces: "Pièces",
    urgency: "Urgence",
    order_date: "Date commande",
    delivery_date_office: "Livraison bureau",
    delivery_date_client: "Livraison client",
    commercial: "Commercial",
    commission: "Commission",
    tracking_number: "N° de suivi",
    tracking_link: "Lien de suivi",
    selling_price: "Prix vente",
    margin: "Marge brute",
    status: "Statut",

    // Status translations
    "status_commandée": "COMMANDÉE",
    "status_impression": "IMPRESSION",
    "status_couture": "COUTURE",
    "status_livraison bureau": "LIVRAISON BUREAU",
    "status_en cours de livraison client": "EN COURS DE LIVRAISON CLIENT",
    "status_livrée": "LIVRÉE",

    // Urgency translations
    urgency_urgent: "Urgent",
    urgency_prioritaire: "Prioritaire",
    urgency_classique: "Classique",
    urgency_non_urgent: "Non urgent",

    // Commercial KPIs
    month_ca: "CA du mois",
    year_ca: "CA de l'année",
    month_commission: "Commission du mois",
    year_commission: "Commission année",
    my_ca_commissions: "Mon CA et commissions",
    archives: "Archives",
    delivered_orders_by_month: "Commandes livrées classées par mois",
    email_templates_title: "Templates emails commerciaux",
    email_templates_nav: "Templates emails",
    quotes_nav: "Devis",
    client_quotes_nav: "Devis Clients",
    client_quotes_title: "Devis Clients",
    client_quotes_desc: "Devis générés par les commerciaux et les clients",
    confirm_delete_quote: "Supprimer ce devis ?",
    quote_deleted: "Devis supprimé",
    quotes_title: "Création de Devis",
    quotes_desc: "Créez et gérez vos devis clients",
    new_quote: "Nouveau devis",
    quote_number: "N° Devis",
    quote_date: "Date",
    quote_expiry: "Validité",
    quote_client: "Client",
    quote_total: "Total TTC",
    quote_status: "Statut",
    add_line: "Ajouter un produit",
    select_product: "Sélectionner un produit",
    quantity: "Quantité",
    unit_price: "Prix unitaire HT",
    line_total: "Total HT",
    subtotal_ht: "Sous-total HT",
    delivery_fee: "Frais de livraison HT",
    total_ht: "Total HT",
    tva: "TVA",
    total_ttc: "Total TTC",
    create_quote: "Créer le devis",
    download_pdf: "Télécharger PDF",
    delivery_free: "Livraison offerte",
    delivery_fee_info: "Livraison 24€ HT (offerte dès 1400€ HT)",
    no_quotes: "Aucun devis",
    no_search_results: "Aucun résultat pour cette recherche",
    search_quotes_placeholder: "Rechercher par n° devis, nom ou téléphone",
    quote_created: "Devis créé avec succès",
    quote_sent: "Devis envoyé par email",
    send_to_client: "Envoyer",
    sent: "Envoyé",
    client_email_label: "Email du client",
    client_email_hint: "Pour envoyer le devis PDF par email",
    product_pricing_title: "Devis Produit - Grille tarifaire",
    product_pricing_desc: "Définissez les prix par tranche de quantité pour chaque produit",
    price_per_unit: "Prix/pièce (€)",
    pricing_saved: "Grille tarifaire sauvegardée",
    my_quotes: "Mes devis",
    pending: "En attente",
    designer_dashboard: "Dashboard Designer",
    designs_todo: "Designs à faire",
    designs_per_month: "Designs réalisés par mois",
    month_earnings: "Gains du mois en cours",
    prev_month_earnings: "Gains du mois M-1",
    design_submitted: "Design envoyé",
    design_link_image_only: "Le lien doit pointer vers une image (.png, .jpg, .jpeg)",
    no_designs: "Aucun design en attente",
    instructions: "Consignes",
    download_files: "Télécharger les fichiers",
    client_files: "FICHIERS DU CLIENT",
    revisions: "Révisions",
    paste_design_link: "Collez le lien de votre design",
    send_design: "Envoyer",
    design_sent: "Design envoyé - en attente de validation",
    open_patterns_dropbox: "Ouvrir les Patterns Dropbox",
    design_requests_title: "Demandes de Design",
    design_requests_desc: "Demandez un design pour vos clubs clients",
    design_requests_nav: "Demander un design",
    designs_nav: "Designs",
    new_design_request: "Nouvelle demande",
    club_name: "Nom du club",
    instructions_label: "Consignes pour le designer",
    instructions_placeholder: "Décrivez le design souhaité (couleurs, logos, style...)",
    instructions_auto_translate: "Les consignes seront automatiquement traduites en anglais pour le designer",
    files_link_label: "Lien fichiers (logos, couleurs...)",
    send_request: "Envoyer la demande",
    design_requested: "Demande de design envoyée",
    no_design_requests: "Aucune demande de design",
    view_design: "Voir le design",
    revision_comment_placeholder: "Décrivez les modifications souhaitées...",
    request_revision: "Demander une révision",
    validate_design: "Valider définitivement le design",
    design_validated: "Design validé",
    countdown_remaining: "Il reste",
    countdown_late: "RETARD",
    countdown_day_suffix: "j",
    revision_sent: "Révision demandée",
    invoice_recap: "Récap Factures",
    invoice_recap_nav: "Récap Factures Designer",
    invoice_recap_desc: "Historique des designs validés et montants à payer",
    no_invoices: "Aucune facture",
    year_earnings: "Gains Année",
    pending_requests: "Demandes en cours",
    treated_requests: "Demandes traitées",
    edit_design_request: "Modifier la demande",
    confirm_delete_design: "Supprimer cette demande de design ?",
    confirm_delete_revision: "Supprimer cette demande de révision ?",
    revision_deleted: "Révision supprimée",
    design_deleted: "Demande supprimée",
    design_updated: "Demande mise à jour",
    designer_archives_title: "ARCHIVES",
    validate_confirm_title: "VALIDER DÉFINITIVEMENT LE VISUEL",
    validate_confirm_message: "Vous êtes sur le point de valider définitivement le visuel pour « {club} ».",
    validate_confirm_warning: "Cette action est irréversible. Une fois validé, le design sera considéré comme terminé et facturé au designer.",
    validate_definitive: "VALIDER DÉFINITIVEMENT",
    duplicate_club_title: "Demande impossible",
    understood: "Compris",
    cancel: "Annuler",
    email_templates_desc: "Modèles d'emails prêts à l'emploi pour votre prospection et suivi client",
    tpl_prospection: "Premier contact",
    tpl_devis: "Envoi de proposition",
    tpl_relance_devis: "Relance devis sans réponse",
    tpl_relance_contact: "Relance prise de contact",
    tpl_suivi_satisfaction: "Suivi satisfaction",
    tpl_fidelisation: "Fidélisation / Nouvelle saison",
    email_subject: "Objet",
    copy: "Copier",
    copied: "Copié !",

    // Orders page
    orders_title: "Commandes",
    new_order: "Nouvelle commande",
    order_number: "N° Commande",
    search_client: "Rechercher par nom ou entreprise...",
    add_client: "Nouveau client",
    firstname: "Prénom",
    postal_code: "Code postal",
    city: "Ville",
    delivery_preview: "Prévisualisation des dates",
    order_lines: "Lignes de commande",
    add_line: "Ajouter une ligne",
    product: "Produit",
    quantity: "Quantité",
    unit_cost: "Coût unitaire",
    weight_kg: "Poids (kg)",
    unit_price: "Prix unitaire",
    subtotal: "Sous-total",
    transport_estimate: "Estimation transport",
    cost_per_kg: "Coût/kg",
    fixed_fee: "Frais fixe",
    total_weight: "Poids total",
    transport_cost: "Coût transport",
    selling_price_eur: "Prix de vente EUR",
    selling_price_vnd: "Prix de vente VND",
    profit: "PROFIT",
    sale_minus_product: "Vente - Produit",
    sale_minus_all: "Vente - Produit - Transport",
    dropbox_link: "Lien Dropbox",
    save_order: "Enregistrer la commande",
    update_order: "Mettre à jour",
    required_fields_missing: "Champs obligatoires manquants",
    images: "Images",
    add_image: "Ajouter une image",
    upload_image: "Télécharger",

    // Tracking & Details
    track_package: "SUIVRE LE COLIS",
    add_tracking: "Ajouter tracking",
    add_weight: "Ajouter poids",
    create_colis: "Créer un colis",
    select_at_least_2: "Sélectionnez au moins 2 commandes pour créer un colis",
    package: "Colis",

    // Transport Dashboard - Factures & Colis
    invoices_title: "Factures",
    uninvoiced_packages: "Colis non facturés",
    create_invoice: "Créer Facture",
    invoices_list: "Factures",
    invoice_number: "N°",
    invoice_date: "Date",
    invoice_packages: "Colis",
    invoice_weight: "Poids",
    invoice_total: "Total VND",
    invoice_status: "Statut",
    invoice_paid: "Payée",
    invoice_pending: "En attente",
    no_invoices: "Aucune facture",
    orders_label: "Commandes",
    invoiced_label: "Facturé",
    invoiced_yes: "Oui",
    invoiced_no: "Non",
    colis_header: "COLIS",
    colis_orders_count: "commandes",
    suivi: "Suivi",
    ignore: "Ignorer",
    colis_name: "Nom du colis",
    piece_type: "Type de produit",
    estimated_weight: "Poids estimé",
    tracking_link_label: "Lien de suivi du colis",
    tracking_number_label: "Numéro du colis",
    detail: "Détail",
    tissu: "Tissu",
    quantities: "Quantités",
    quantities_detail: "Détail des quantités",
    product_name: "Nom du produit",

    // Clients
    clients_title: "Clients",
    new_client: "Nouveau client",
    company_name: "Société",
    total_orders: "Commandes",
    total_ca: "CA total",

    // Products
    products_title: "Produits",
    new_product: "Nouveau produit",
    product_name: "Nom du produit",
    cost: "Coût",
    weight: "Poids",

    // Archives
    archives_title: "Archives",
    archives_subtitle: "Commandes livrées regroupées par mois",
    delivered_orders: "commande(s) livrée(s)",
    material_cost: "Coût matière",
    transport_cost_label: "Coût transport",
    delivery_cost: "Coût livraison",

    // Commercials
    commercials_title: "Commerciaux",
    commercials_subtitle: "Gestion des comptes commerciaux et commissions",
    new_commercial: "Nouveau commercial",
    zone: "Zone couverte",
    commission_rate: "Commission appliquée",
    weekly_recap: "Récapitulatif hebdomadaire",
    weekly_recap_subtitle: "Aperçu des performances : CA et commissions par commercial",
    week_orders: "Cmd semaine",
    week_ca: "CA semaine",
    week_commission: "Com. semaine",
    month_orders: "Cmd mois",
    month_ca_label: "CA mois",
    month_commission_label: "Com. mois",
    commissions_by_month: "Commissions par mois / année",
    commissions_by_month_subtitle: "Détail des commissions calculées automatiquement pour chaque commercial",
    months_count: "mois",

    // Partners
    partners_title: "Partenaires",
    partners_subtitle: "Gestion des accès partenaires (Imprimeur, Couture, Transport, Manager)",
    new_partner: "Nouveau partenaire",
    partner_type: "Type de partenaire",
    allowed_statuses: "Statuts autorisés",
    status_help: "Le 1er statut = ce que le partenaire voit, les suivants = ce qu'il peut appliquer",

    // Expenses
    expenses_title: "Dépenses",
    new_expense: "Nouvelle dépense",
    expense_type: "Type",
    amount: "Montant",
    description: "Description",
    currency: "Devise",

    // Transport
    transport_title: "Coûts de transport",
    transport_subtitle: "Gestion des coûts par pays",
    add_country: "Ajouter un pays",
    monthly_report: "Compte rendu mensuel - Livraisons",
    monthly_report_subtitle: "Nombre de commandes livrées par mois",
    total_delivered: "commande(s) livrée(s)",
    delivered_count: "Commandes livrées",

    // Settings
    settings_title: "Paramètres",
    eur_vnd_rate: "Taux EUR/VND",

    // Partner Dashboard
    partner_orders: "Commandes à traiter",
    partner_orders_subtitle: "en attente de votre action",
    pending_orders: "commande(s) en attente",
    no_pending_orders: "Aucune commande en attente",
    validate: "VALIDER",
    weight_label: "Poids (kg)",
    address_delivery: "Adresse de livraison",
    partner_archives: "Archives - Tâches terminées",
    partner_archives_subtitle: "commande(s) traitée(s), regroupées par mois",
    delivery_expected: "Livraison prévue",
    not_provided: "Non renseignée",

    // Partner types
    type_imprimeur: "Imprimeur",
    type_couture: "Couture",
    type_transport: "Transport",
    type_manager: "Manager",
    type_createur_fichiers: "Créateur Fichiers",
    type_checkin: "Checkin",

    // Manager Dashboard
    manager_title: "Tableau de bord Manager",
    manager_subtitle: "Suivi des commandes en cours",

    // Image
    click_to_enlarge: "Cliquer pour agrandir",
    no_image: "Pas d'image",
    image_popup_title: "Images de la commande",

    // Notification
    new_order_notification: "Nouvelle commande !",
    new_orders_notification: "nouvelles commandes !",
    alert_orange_notification: "Attention : commande proche de la date limite !",
    alert_red_notification: "Urgence : commande en retard !",

    // Order detail profit
    estimated_profit: "PROFIT ESTIMÉ",
    product_cost_label: "Coût produit",
    product_lines: "lignes de produit",

    // Advanced filters
    filter_by_status: "Filtrer par statut",
    filter_by_date: "Filtrer par date",
    filter_by_commercial: "Filtrer par commercial",
    all_statuses: "Tous les statuts",
    all_commercials: "Tous les commerciaux",
    from_date: "Du",
    to_date: "Au",
    reset_filters: "Réinitialiser",
    order_list: "Liste des commandes",
    no_orders: "Aucune commande",

    // Status flow
    status_flow: "Flux de statut",

    // Password
    password: "Mot de passe",
    name: "Nom",

    // Support v2
    ticket_title: "Titre",
    ticket_title_placeholder: "Résumé de votre demande...",
    active_tickets: "Demandes actives",
    archived_tickets: "Archives",
    archive: "Archiver",
    unarchive: "Désarchiver",
    edit_response: "Modifier",
    no_archived_tickets: "Aucune demande archivée.",
    size_guide_images: "Images du guide des tailles",
    size_guide_images_desc: "Gérez les images affichées dans le guide des tailles (max 4).",
    add_image_url: "Ajouter une image",
    upload_file: "Uploader un fichier",
    image_added: "Image ajoutée",
    image_removed: "Image supprimée",
    images_saved: "Images sauvegardées",
    max_images_reached: "Maximum 4 images atteint",
    alert_sounds_title: "Sons d'alerte",
    alert_sounds_desc: "Uploadez vos propres fichiers audio pour les notifications de commandes.",
    new_order_sound: "Son nouvelle commande",
    status_change_sound: "Son changement de statut",
    upload_audio: "Uploader un fichier audio",
    sound_uploaded: "Son uploadé avec succès",
    sounds_saved: "Sons sauvegardés",
    remove_sound: "Supprimer le son",
    play_sound: "Écouter",
    stop_sound: "Arrêter",
    status_update_notification: "Statut mis à jour !",
    current_month: "Mois en cours",
    year: "Année",
    // Premium client dashboard
    premium_title: "PARTNER PREMIUM PANTHER",
    premium_home: "Accueil",
    premium_archives: "Archives",
    premium_size_guide: "Guide des tailles",
    premium_personalization: "Personnalisation",
    premium_contact: "Contact",
    premium_orders_active: "Commandes en cours",
    premium_orders_total: "Commandes totales",
    premium_delivery_address: "Adresse de livraison",
    premium_no_orders: "Aucune commande en cours",
    premium_order_archives: "Archives des commandes",
    premium_no_archives: "Aucune commande livrée",
    premium_contact_name: "MIRALLES Cédric",
    premium_contact_role: "Responsable Panther",
    premium_whatsapp: "Contacter sur WhatsApp",
    premium_zalo: "Contacter sur Zalo",
    premium_social_title: "Rejoignez-nous sur les réseaux",
    premium_payment_title: "Conditions de paiement & Frais",
    premium_add_line: "Ajouter une ligne",
    premium_export_excel: "Exporter Excel",
    premium_exporting: "Export...",
    premium_logout: "Déconnexion",
    premium_client_space: "Espace Premium",
    // Production stats (imprimeur/couture)
    prod_this_year: "Cette année, PANTHER a produit",
    prod_pieces: "pièces",
    prod_warning: "Respectez les dates de production. Les commandes qui sont réalisées en retard auront une pénalité, donc n'oubliez pas de valider les statuts de chaque commande au bon moment. Merci.",
    prod_late_title: "Ce mois-ci, vous avez",
    prod_late_suffix: "commandes en retard !",
    prod_late_see: "Voir les commandes en retard",
    prod_late_order: "Commande",
    prod_late_deadline: "Date max livraison couture",
    prod_late_changed: "Date changement statut",
    prod_late_days: "jours de retard",
    prod_late_still: "Toujours en attente",
  },

  en: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    forgot_password: "Forgot password?",
    forgot_password_desc: "Enter your email to receive a reset link.",
    send_reset_link: "Send reset link",
    reset_email_sent: "A reset email has been sent if this account exists.",
    back_to_login: "Back to login",
    my_information: "My information",
    change_password: "Change password",
    current_password: "Current password",
    new_password: "New password",
    confirm_password: "Confirm password",
    password: "Password",
    enable_notifications: "Enable notifications",
    notifications_enabled: "Notifications enabled",
    notifications_denied: "Notifications denied by browser",
    allowed_statuses: "Allowed statuses",
    password_changed: "Password changed successfully",
    password_error: "Error changing password",
    new_product: "New product",
    size_guide: "Size Guide",
    size_guide_desc: "Size reference for Panther textile products.",
    size: "Size",
    chest: "Chest",
    waist: "Waist",
    hip: "Hip",
    support: "Support",
    new_request: "New request",
    your_message: "Your message",
    describe_issue: "Describe your request or issue...",
    send: "Send",
    my_tickets: "My requests",
    no_tickets: "No requests yet.",
    ticket_sent: "Request sent successfully",
    open: "Pending",
    closed: "Answered",
    admin_response: "Admin response",
    respond: "Reply",
    type_response: "Type your response...",
    response_sent: "Response sent",
    personalization: "Client personalization",
    client_selection: "Client selection",
    select_client: "Select a client",
    new_client: "New client",
    personalization_lines: "Personalization lines",
    name: "Name",
    number: "Number",
    add_line: "Add a line",
    validate_download: "Validate and download Excel",
    fill_fields: "Please select a client and fill at least one line.",
    file_downloaded: "File downloaded",
    last_name: "Last name",
    first_name: "First name",
    country: "Country",
    phone: "Phone",
    address: "Address",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    close: "Close",
    search: "Search",
    actions: "Actions",
    yes: "Yes",
    no: "No",
    logout: "Logout",
    language: "Language",
    login: "Login",
    login_subtitle: "Access your management portal",
    connecting: "Connecting...",
    connect: "Sign in",
    order_management: "Order management and tracking",

    nav_dashboard: "Dashboard",
    nav_orders: "Orders",
    nav_clients: "Clients",
    nav_products: "Products",
    nav_archives: "Archives",
    nav_commercials: "Sales Reps",
    nav_partners: "Partners",
    nav_expenses: "Expenses",
    nav_transport: "Transport",
    transport_orders_nav: "Delivery Orders",
    transport_orders_title: "Delivery Orders",
    transport_recap_nav: "Transport Recap",
    transport_recap_title: "Transport Recap",
    transport_unpaid: "Pending Payment",
    transport_paid_archives: "Paid Archives",
    no_transport_orders: "No delivery orders",
    tracking_saved: "Tracking saved",
    checkin_title: "Check-in",
    checkin_orders: "Orders to process",
    no_checkin_orders: "No pending orders",
    print_delivery: "PRINT DELIVERY",
    number_of_boxes: "Number of boxes",
    generate_label: "Generate label",
    label_generated: "Label generated",
    mark_shipped: "SHIP NOW",
    confirm_ship: "Confirm shipment?",
    order_shipped: "Order shipped",
    weight_required: "Weight is required",
    tracking_number: "Tracking number",
    tracking_link: "Tracking link",
    track_package: "Track package",
    estimated_short: "Est.",
    delivered_short: "Delivered",
    delivery_col: "Delivery",
    validate_package: "Validate package (irreversible)",
    package_validated: "Package validated",
    weight_kg: "Weight (kg)",
    price_vnd: "Price (VND)",
    weight_price_required: "Weight and price required",
    transport_validate_warning: "This action is irreversible. Weight and price cannot be changed after validation.",
    order_name: "Order",
    order_date_col: "Date",
    select_all: "Select all",
    mark_as_paid: "Pay",
    payment_date: "Payment date",
    validated: "Validated",
    country: "Country",
    address: "Address",
    phone: "Phone",
    pieces: "Pieces",
    client: "Client",
    nav_settings: "Settings",

    dashboard_title: "Dashboard",
    dashboard_subtitle: "Overview of your activity",
    fabric_alert_text: "FABRIC ORDER REMINDER",
    alert_dismissed: "Alert dismissed",
    click_to_dismiss: "Click to dismiss",
    fabric_question: "Has the fabric been ordered?",
    fabric_confirm: "OK Confirmed",
    all_companies: "All companies",
    monthly_sales: "Monthly sales",
    france_vs_vn: "Panther France vs Vietnam",
    total_sales: "Total sales",
    total_costs: "Total costs",
    gross_margin: "Gross margin",
    commissions: "Commissions",
    expenses: "Expenses",
    net_profit: "Net profit",
    pieces_sold: "Pieces sold",
    pieces_sold_monthly: "Pieces sold per month",
    orders_in_progress: "Orders in progress",
    no_orders_in_progress: "No orders in progress",
    change_status: "CHANGE STATUS",
    delivery_office: "OFFICE DEL.",
    delivery_couture: "SEWING DEL.",
    delivery_client: "CLIENT DEL.",
    order: "Order",
    orders_count: "order(s)",
    client: "Client",
    country: "Country",
    phone: "Phone",
    email: "Email",
    address: "Address",
    company: "Company",
    pieces: "Pieces",
    urgency: "Urgency",
    order_date: "Order date",
    delivery_date_office: "Office delivery",
    delivery_date_client: "Client delivery",
    commercial: "Sales rep",
    commission: "Commission",
    tracking_number: "Tracking #",
    tracking_link: "Tracking link",
    selling_price: "Selling price",
    margin: "Gross margin",
    status: "Status",

    "status_commandée": "ORDERED",
    "status_impression": "PRINTING",
    "status_couture": "SEWING",
    "status_livraison bureau": "OFFICE DELIVERY",
    "status_en cours de livraison client": "CLIENT DELIVERY IN PROGRESS",
    "status_livrée": "DELIVERED",

    urgency_urgent: "Urgent",
    urgency_prioritaire: "Priority",
    urgency_classique: "Standard",
    urgency_non_urgent: "Non urgent",

    month_ca: "Month revenue",
    year_ca: "Year revenue",
    month_commission: "Month commission",
    year_commission: "Year commission",
    my_ca_commissions: "My revenue & commissions",
    archives: "Archives",
    delivered_orders_by_month: "Delivered orders by month",
    email_templates_title: "Commercial email templates",
    email_templates_nav: "Email templates",
    quotes_nav: "Quotes",
    client_quotes_nav: "Client Quotes",
    client_quotes_title: "Client Quotes",
    client_quotes_desc: "Quotes generated by commercials and clients",
    confirm_delete_quote: "Delete this quote?",
    quote_deleted: "Quote deleted",
    quotes_title: "Create Quote",
    quotes_desc: "Create and manage your client quotes",
    new_quote: "New quote",
    quote_number: "Quote #",
    quote_date: "Date",
    quote_expiry: "Valid until",
    quote_client: "Client",
    quote_total: "Total incl. tax",
    quote_status: "Status",
    add_line: "Add product",
    select_product: "Select a product",
    quantity: "Quantity",
    unit_price: "Unit price excl. tax",
    line_total: "Total excl. tax",
    subtotal_ht: "Subtotal excl. tax",
    delivery_fee: "Delivery fee excl. tax",
    total_ht: "Total excl. tax",
    tva: "VAT",
    total_ttc: "Total incl. tax",
    create_quote: "Create quote",
    download_pdf: "Download PDF",
    delivery_free: "Free delivery",
    delivery_fee_info: "Delivery €24 excl. tax (free from €1400 excl. tax)",
    no_quotes: "No quotes",
    no_search_results: "No results for this search",
    search_quotes_placeholder: "Search by quote #, name or phone",
    quote_created: "Quote created successfully",
    quote_sent: "Quote sent by email",
    send_to_client: "Send",
    sent: "Sent",
    client_email_label: "Client email",
    client_email_hint: "To send the PDF quote by email",
    product_pricing_title: "Product Pricing Grid",
    product_pricing_desc: "Set prices per quantity tier for each product",
    price_per_unit: "Price/unit (€)",
    pricing_saved: "Pricing saved",
    my_quotes: "My quotes",
    pending: "Pending",
    designer_dashboard: "Designer Dashboard",
    designs_todo: "Designs to do",
    designs_per_month: "Designs completed per month",
    month_earnings: "Current month earnings",
    prev_month_earnings: "Previous month earnings",
    design_submitted: "Design submitted",
    design_link_image_only: "The link must point to an image (.png, .jpg, .jpeg)",
    no_designs: "No pending designs",
    instructions: "Instructions",
    download_files: "Download files",
    client_files: "CLIENT FILES",
    revisions: "Revisions",
    paste_design_link: "Paste your design link",
    send_design: "Send",
    design_sent: "Design sent - awaiting validation",
    open_patterns_dropbox: "Open Patterns on Dropbox",
    design_requests_title: "Design Requests",
    design_requests_desc: "Request a design for your client clubs",
    design_requests_nav: "Request a design",
    designs_nav: "Designs",
    new_design_request: "New request",
    club_name: "Club name",
    instructions_label: "Instructions for the designer",
    instructions_placeholder: "Describe the design (colors, logos, style...)",
    instructions_auto_translate: "Instructions will be automatically translated to English",
    files_link_label: "Files link (logos, colors...)",
    send_request: "Send request",
    design_requested: "Design request sent",
    no_design_requests: "No design requests",
    view_design: "View design",
    revision_comment_placeholder: "Describe the changes needed...",
    request_revision: "Request revision",
    validate_design: "Validate design permanently",
    design_validated: "Design validated",
    countdown_remaining: "Remaining",
    countdown_late: "LATE",
    countdown_day_suffix: "d",
    revision_sent: "Revision requested",
    invoice_recap: "Invoice Recap",
    invoice_recap_nav: "Designer Invoices",
    invoice_recap_desc: "History of validated designs and amounts to pay",
    no_invoices: "No invoices",
    year_earnings: "Year Earnings",
    pending_requests: "Pending requests",
    treated_requests: "Treated requests",
    edit_design_request: "Edit request",
    confirm_delete_design: "Delete this design request?",
    confirm_delete_revision: "Delete this revision request?",
    revision_deleted: "Revision deleted",
    design_deleted: "Request deleted",
    design_updated: "Request updated",
    designer_archives_title: "ARCHIVES",
    validate_confirm_title: "VALIDATE DESIGN PERMANENTLY",
    validate_confirm_message: "You are about to permanently validate the design for \"{club}\".",
    validate_confirm_warning: "This action is irreversible. Once validated, the design will be considered complete and invoiced to the designer.",
    validate_definitive: "VALIDATE PERMANENTLY",
    duplicate_club_title: "Request not allowed",
    understood: "Understood",
    cancel: "Cancel",
    email_templates_desc: "Ready-to-use email templates for your prospecting and client follow-up",
    tpl_prospection: "First contact",
    tpl_devis: "Quote proposal",
    tpl_relance_devis: "Quote follow-up",
    tpl_relance_contact: "Contact follow-up",
    tpl_suivi_satisfaction: "Satisfaction follow-up",
    tpl_fidelisation: "Loyalty / New season",
    email_subject: "Subject",
    copy: "Copy",
    copied: "Copied!",

    orders_title: "Orders",
    new_order: "New order",
    order_number: "Order #",
    search_client: "Search by name or company...",
    add_client: "New client",
    firstname: "First name",
    postal_code: "Postal code",
    city: "City",
    delivery_preview: "Delivery date preview",
    order_lines: "Order lines",
    add_line: "Add a line",
    product: "Product",
    quantity: "Quantity",
    unit_cost: "Unit cost",
    weight_kg: "Weight (kg)",
    unit_price: "Unit price",
    subtotal: "Subtotal",
    transport_estimate: "Transport estimate",
    cost_per_kg: "Cost/kg",
    fixed_fee: "Fixed fee",
    total_weight: "Total weight",
    transport_cost: "Transport cost",
    selling_price_eur: "Selling price EUR",
    selling_price_vnd: "Selling price VND",
    profit: "PROFIT",
    sale_minus_product: "Sale - Product",
    sale_minus_all: "Sale - Product - Transport",
    dropbox_link: "Dropbox link",
    save_order: "Save order",
    update_order: "Update",
    required_fields_missing: "Required fields missing",
    images: "Images",
    add_image: "Add image",
    upload_image: "Upload",

    // Tracking & Details
    track_package: "TRACK PACKAGE",
    add_tracking: "Add tracking",
    add_weight: "Add weight",
    create_colis: "Create package",
    select_at_least_2: "Select at least 2 orders to create a package",
    package: "Package",

    // Transport Dashboard - Invoices & Packages
    invoices_title: "Invoices",
    uninvoiced_packages: "Uninvoiced packages",
    create_invoice: "Create Invoice",
    invoices_list: "Invoices",
    invoice_number: "No.",
    invoice_date: "Date",
    invoice_packages: "Packages",
    invoice_weight: "Weight",
    invoice_total: "Total VND",
    invoice_status: "Status",
    invoice_paid: "Paid",
    invoice_pending: "Pending",
    no_invoices: "No invoices",
    orders_label: "Orders",
    invoiced_label: "Invoiced",
    invoiced_yes: "Yes",
    invoiced_no: "No",
    colis_header: "PACKAGE",
    colis_orders_count: "orders",
    suivi: "Tracking",
    ignore: "Ignore",
    colis_name: "Package name",
    piece_type: "Product type",
    estimated_weight: "Estimated weight",
    tracking_link_label: "Package tracking link",
    tracking_number_label: "Package number",
    detail: "Detail",
    tissu: "Fabric",
    quantities: "Quantities",
    quantities_detail: "Quantities detail",
    product_name: "Product name",

    clients_title: "Clients",
    new_client: "New client",
    company_name: "Company",
    total_orders: "Orders",
    total_ca: "Total revenue",

    products_title: "Products",
    new_product: "New product",
    product_name: "Product name",
    cost: "Cost",
    weight: "Weight",

    archives_title: "Archives",
    archives_subtitle: "Delivered orders grouped by month",
    delivered_orders: "delivered order(s)",
    material_cost: "Material cost",
    transport_cost_label: "Transport cost",
    delivery_cost: "Delivery cost",

    commercials_title: "Sales Reps",
    commercials_subtitle: "Manage sales rep accounts and commissions",
    new_commercial: "New sales rep",
    zone: "Coverage zone",
    commission_rate: "Commission rate",
    weekly_recap: "Weekly recap",
    weekly_recap_subtitle: "Performance overview: revenue and commissions by sales rep",
    week_orders: "Week orders",
    week_ca: "Week revenue",
    week_commission: "Week comm.",
    month_orders: "Month orders",
    month_ca_label: "Month revenue",
    month_commission_label: "Month comm.",
    commissions_by_month: "Commissions by month / year",
    commissions_by_month_subtitle: "Auto-calculated commission details for each sales rep",
    months_count: "months",

    partners_title: "Partners",
    partners_subtitle: "Manage partner access (Printer, Sewing, Transport, Manager)",
    new_partner: "New partner",
    partner_type: "Partner type",
    allowed_statuses: "Allowed statuses",
    status_help: "1st status = orders visible, next ones = applicable statuses",

    expenses_title: "Expenses",
    new_expense: "New expense",
    expense_type: "Type",
    amount: "Amount",
    description: "Description",
    currency: "Currency",

    transport_title: "Transport costs",
    transport_subtitle: "Cost management by country",
    add_country: "Add a country",
    monthly_report: "Monthly report - Deliveries",
    monthly_report_subtitle: "Number of delivered orders per month",
    total_delivered: "delivered order(s)",
    delivered_count: "Delivered orders",

    settings_title: "Settings",
    eur_vnd_rate: "EUR/VND rate",

    partner_orders: "Orders to process",
    partner_orders_subtitle: "awaiting your action",
    pending_orders: "pending order(s)",
    no_pending_orders: "No pending orders",
    validate: "VALIDATE",
    weight_label: "Weight (kg)",
    address_delivery: "Delivery address",
    partner_archives: "Archives - Completed tasks",
    partner_archives_subtitle: "processed order(s), grouped by month",
    delivery_expected: "Expected delivery",
    not_provided: "Not provided",

    type_imprimeur: "Printer",
    type_couture: "Sewing",
    type_transport: "Transport",
    type_manager: "Manager",
    type_createur_fichiers: "File Creator",
    type_checkin: "Checkin",

    manager_title: "Manager Dashboard",
    manager_subtitle: "Track orders in progress",

    click_to_enlarge: "Click to enlarge",
    no_image: "No image",
    image_popup_title: "Order images",

    new_order_notification: "New order!",
    new_orders_notification: "new orders!",
    alert_orange_notification: "Warning: order approaching deadline!",
    alert_red_notification: "Urgent: order overdue!",

    estimated_profit: "ESTIMATED PROFIT",
    product_cost_label: "Product cost",
    product_lines: "product lines",

    filter_by_status: "Filter by status",
    filter_by_date: "Filter by date",
    filter_by_commercial: "Filter by sales rep",
    all_statuses: "All statuses",
    all_commercials: "All sales reps",
    from_date: "From",
    to_date: "To",
    reset_filters: "Reset",
    order_list: "Order list",
    no_orders: "No orders",

    status_flow: "Status flow",

    password: "Password",
    name: "Name",

    // Support v2
    ticket_title: "Title",
    ticket_title_placeholder: "Summary of your request...",
    active_tickets: "Active requests",
    archived_tickets: "Archives",
    archive: "Archive",
    unarchive: "Unarchive",
    edit_response: "Edit",
    no_archived_tickets: "No archived requests.",
    size_guide_images: "Size guide images",
    size_guide_images_desc: "Manage images displayed in the size guide (max 4).",
    add_image_url: "Add image",
    upload_file: "Upload file",
    image_added: "Image added",
    image_removed: "Image removed",
    images_saved: "Images saved",
    max_images_reached: "Maximum 4 images reached",
    alert_sounds_title: "Alert sounds",
    alert_sounds_desc: "Upload your own audio files for order notifications.",
    new_order_sound: "New order sound",
    status_change_sound: "Status change sound",
    upload_audio: "Upload audio file",
    sound_uploaded: "Sound uploaded successfully",
    sounds_saved: "Sounds saved",
    remove_sound: "Remove sound",
    play_sound: "Play",
    stop_sound: "Stop",
    status_update_notification: "Status updated!",
    current_month: "Current month",
    year: "Year",
    // Premium client dashboard
    premium_title: "PREMIUM PARTNER PANTHER",
    premium_home: "Home",
    premium_archives: "Archives",
    premium_size_guide: "Size Guide",
    premium_personalization: "Personalization",
    premium_contact: "Contact",
    premium_orders_active: "Active orders",
    premium_orders_total: "Total orders",
    premium_delivery_address: "Delivery address",
    premium_no_orders: "No active orders",
    premium_order_archives: "Order archives",
    premium_no_archives: "No delivered orders",
    premium_contact_name: "MIRALLES Cédric",
    premium_contact_role: "Panther Manager",
    premium_whatsapp: "Contact on WhatsApp",
    premium_zalo: "Contact on Zalo",
    premium_social_title: "Follow us on social media",
    premium_payment_title: "Payment terms & Fees",
    premium_add_line: "Add a line",
    premium_export_excel: "Export Excel",
    premium_exporting: "Exporting...",
    premium_logout: "Logout",
    premium_client_space: "Premium Space",
    // Production stats
    prod_this_year: "This year, PANTHER has produced",
    prod_pieces: "pieces",
    prod_warning: "Respect production deadlines. Late orders will incur a penalty, so don't forget to validate the status of each order on time. Thank you.",
    prod_late_title: "This month, you have",
    prod_late_suffix: "late orders!",
    prod_late_see: "See late orders",
    prod_late_order: "Order",
    prod_late_deadline: "Couture delivery deadline",
    prod_late_changed: "Status change date",
    prod_late_days: "days late",
    prod_late_still: "Still pending",
  },

  vi: {
    loading: "Đang tải...",
    save: "Lưu",
    cancel: "Hủy",
    forgot_password: "Quên mật khẩu?",
    forgot_password_desc: "Nhập email để nhận liên kết đặt lại.",
    send_reset_link: "Gửi liên kết",
    reset_email_sent: "Email đặt lại đã được gửi nếu tài khoản tồn tại.",
    back_to_login: "Quay lại đăng nhập",
    my_information: "Thông tin của tôi",
    change_password: "Đổi mật khẩu",
    current_password: "Mật khẩu hiện tại",
    new_password: "Mật khẩu mới",
    confirm_password: "Xác nhận mật khẩu",
    password: "Mật khẩu",
    enable_notifications: "Bật thông báo",
    notifications_enabled: "Thông báo đã bật",
    notifications_denied: "Trình duyệt từ chối thông báo",
    allowed_statuses: "Trạng thái được phép",
    password_changed: "Đổi mật khẩu thành công",
    password_error: "Lỗi khi đổi mật khẩu",
    new_product: "Sản phẩm mới",
    size_guide: "Hướng dẫn kích cỡ",
    size_guide_desc: "Bảng kích cỡ tham khảo cho sản phẩm dệt may Panther.",
    size: "Kích cỡ",
    chest: "Ngực",
    waist: "Eo",
    hip: "Hông",
    support: "Hỗ trợ",
    new_request: "Yêu cầu mới",
    your_message: "Tin nhắn của bạn",
    describe_issue: "Mô tả yêu cầu hoặc vấn đề...",
    send: "Gửi",
    my_tickets: "Yêu cầu của tôi",
    no_tickets: "Chưa có yêu cầu nào.",
    ticket_sent: "Yêu cầu đã gửi thành công",
    open: "Đang chờ",
    closed: "Đã trả lời",
    admin_response: "Phản hồi Admin",
    respond: "Trả lời",
    type_response: "Nhập phản hồi...",
    response_sent: "Phản hồi đã gửi",
    personalization: "Cá nhân hóa khách hàng",
    client_selection: "Chọn khách hàng",
    select_client: "Chọn khách hàng",
    new_client: "Khách hàng mới",
    personalization_lines: "Dòng cá nhân hóa",
    name: "Tên",
    number: "Số",
    add_line: "Thêm dòng",
    validate_download: "Xác nhận và tải Excel",
    fill_fields: "Vui lòng chọn khách hàng và điền ít nhất một dòng.",
    file_downloaded: "Tệp đã tải",
    last_name: "Họ",
    first_name: "Tên",
    country: "Quốc gia",
    phone: "Điện thoại",
    address: "Địa chỉ",
    delete: "Xóa",
    edit: "Sửa",
    create: "Tạo",
    close: "Đóng",
    search: "Tìm kiếm",
    actions: "Hành động",
    yes: "Có",
    no: "Không",
    logout: "Đăng xuất",
    language: "Ngôn ngữ",
    login: "Đăng nhập",
    login_subtitle: "Truy cập cổng quản lý",
    connecting: "Đang kết nối...",
    connect: "Đăng nhập",
    order_management: "Quản lý đơn hàng và theo dõi",

    nav_dashboard: "Bảng điều khiển",
    nav_orders: "Đơn hàng",
    nav_clients: "Khách hàng",
    nav_products: "Sản phẩm",
    nav_archives: "Lưu trữ",
    nav_commercials: "Nhân viên KD",
    nav_partners: "Đối tác",
    nav_expenses: "Chi phí",
    nav_transport: "Vận chuyển",
    transport_orders_nav: "Đơn giao hàng",
    transport_orders_title: "Đơn giao hàng",
    transport_recap_nav: "Tổng kết vận chuyển",
    transport_recap_title: "Tổng kết vận chuyển",
    transport_unpaid: "Chờ thanh toán",
    transport_paid_archives: "Lưu trữ đã thanh toán",
    no_transport_orders: "Không có đơn giao hàng",
    tracking_saved: "Đã lưu tracking",
    checkin_title: "Check-in",
    checkin_orders: "Đơn hàng cần xử lý",
    no_checkin_orders: "Không có đơn hàng chờ",
    print_delivery: "IN NHÃN",
    number_of_boxes: "Số kiện",
    generate_label: "Tạo nhãn",
    label_generated: "Đã tạo nhãn",
    mark_shipped: "GIAO HÀNG",
    confirm_ship: "Xác nhận giao hàng?",
    order_shipped: "Đơn hàng đang giao",
    weight_required: "Cần nhập cân nặng",
    tracking_number: "Số tracking",
    tracking_link: "Link tracking",
    track_package: "Theo dõi gói hàng",
    estimated_short: "Dự kiến",
    delivered_short: "Đã giao",
    delivery_col: "Giao hàng",
    validate_package: "Xác nhận gói hàng (không thể thay đổi)",
    package_validated: "Gói hàng đã xác nhận",
    weight_kg: "Cân nặng (kg)",
    price_vnd: "Giá (VND)",
    weight_price_required: "Cần nhập cân nặng và giá",
    transport_validate_warning: "Hành động này không thể hoàn tác. Cân nặng và giá không thể thay đổi sau khi xác nhận.",
    order_name: "Đơn hàng",
    order_date_col: "Ngày",
    select_all: "Chọn tất cả",
    mark_as_paid: "Thanh toán",
    payment_date: "Ngày thanh toán",
    validated: "Đã xác nhận",
    country: "Quốc gia",
    address: "Địa chỉ",
    phone: "Điện thoại",
    pieces: "Số lượng",
    client: "Khách hàng",
    nav_settings: "Cài đặt",

    dashboard_title: "Bảng điều khiển",
    dashboard_subtitle: "Tổng quan hoạt động",
    fabric_alert_text: "NHẮC ĐẶT VẢI",
    alert_dismissed: "Đã tắt cảnh báo",
    click_to_dismiss: "Nhấn để tắt",
    fabric_question: "Vải đã được đặt chưa?",
    fabric_confirm: "OK Xác nhận",
    all_companies: "Tất cả công ty",
    monthly_sales: "Doanh thu hàng tháng",
    france_vs_vn: "Panther Pháp vs Việt Nam",
    total_sales: "Tổng doanh thu",
    total_costs: "Tổng chi phí",
    gross_margin: "Lợi nhuận gộp",
    commissions: "Hoa hồng",
    expenses: "Chi phí",
    net_profit: "Lợi nhuận ròng",
    pieces_sold: "Sản phẩm đã bán",
    pieces_sold_monthly: "Sản phẩm bán theo tháng",
    orders_in_progress: "Đơn hàng đang xử lý",
    no_orders_in_progress: "Không có đơn hàng đang xử lý",
    change_status: "ĐỔI TRẠNG THÁI",
    delivery_office: "GIAO VĂN PHÒNG",
    delivery_couture: "GIAO MAY",
    delivery_client: "GIAO KHÁCH",
    order: "Đơn hàng",
    orders_count: "đơn hàng",
    client: "Khách hàng",
    country: "Quốc gia",
    phone: "Điện thoại",
    email: "Email",
    address: "Địa chỉ",
    company: "Công ty",
    pieces: "Số lượng",
    urgency: "Độ gấp",
    order_date: "Ngày đặt hàng",
    delivery_date_office: "Giao văn phòng",
    delivery_date_client: "Giao khách hàng",
    commercial: "Nhân viên KD",
    commission: "Hoa hồng",
    tracking_number: "Mã vận đơn",
    tracking_link: "Link theo dõi",
    selling_price: "Giá bán",
    margin: "Lợi nhuận gộp",
    status: "Trạng thái",

    "status_commandée": "ĐÃ ĐẶT HÀNG",
    "status_impression": "ĐANG IN",
    "status_couture": "ĐANG MAY",
    "status_livraison bureau": "GIAO VĂN PHÒNG",
    "status_en cours de livraison client": "ĐANG GIAO CHO KHÁCH",
    "status_livrée": "ĐÃ GIAO",

    urgency_urgent: "Gấp",
    urgency_prioritaire: "Ưu tiên",
    urgency_classique: "Bình thường",
    urgency_non_urgent: "Không gấp",

    month_ca: "Doanh thu tháng",
    year_ca: "Doanh thu năm",
    month_commission: "Hoa hồng tháng",
    year_commission: "Hoa hồng năm",
    my_ca_commissions: "Doanh thu & hoa hồng",
    archives: "Lưu trữ",
    delivered_orders_by_month: "Đơn đã giao theo tháng",
    email_templates_title: "Mẫu email thương mại",
    email_templates_nav: "Mẫu email",
    quotes_nav: "Báo giá",
    client_quotes_nav: "Báo giá khách hàng",
    client_quotes_title: "Báo giá khách hàng",
    client_quotes_desc: "Báo giá được tạo bởi nhân viên và khách hàng",
    confirm_delete_quote: "Xóa báo giá này?",
    quote_deleted: "Đã xóa báo giá",
    quotes_title: "Tạo báo giá",
    quotes_desc: "Tạo và quản lý báo giá khách hàng",
    new_quote: "Báo giá mới",
    quote_number: "Số báo giá",
    quote_date: "Ngày",
    quote_expiry: "Hiệu lực",
    quote_client: "Khách hàng",
    quote_total: "Tổng cộng",
    quote_status: "Trạng thái",
    add_line: "Thêm sản phẩm",
    select_product: "Chọn sản phẩm",
    quantity: "Số lượng",
    unit_price: "Đơn giá",
    line_total: "Thành tiền",
    subtotal_ht: "Tạm tính",
    delivery_fee: "Phí vận chuyển",
    total_ht: "Tổng",
    tva: "VAT",
    total_ttc: "Tổng cộng",
    create_quote: "Tạo báo giá",
    download_pdf: "Tải PDF",
    delivery_free: "Miễn phí vận chuyển",
    delivery_fee_info: "Vận chuyển 24€ (miễn phí từ 1400€)",
    no_quotes: "Không có báo giá",
    no_search_results: "Không có kết quả cho tìm kiếm này",
    search_quotes_placeholder: "Tìm theo số báo giá, tên hoặc điện thoại",
    quote_created: "Đã tạo báo giá",
    quote_sent: "Đã gửi báo giá qua email",
    send_to_client: "Gửi",
    sent: "Đã gửi",
    client_email_label: "Email khách hàng",
    client_email_hint: "Để gửi báo giá PDF qua email",
    product_pricing_title: "Bảng giá sản phẩm",
    product_pricing_desc: "Đặt giá theo số lượng cho mỗi sản phẩm",
    price_per_unit: "Giá/chiếc (€)",
    pricing_saved: "Đã lưu bảng giá",
    my_quotes: "Báo giá của tôi",
    pending: "Đang chờ",
    designer_dashboard: "Bảng điều khiển Designer",
    designs_todo: "Thiết kế cần làm",
    designs_per_month: "Thiết kế hoàn thành theo tháng",
    month_earnings: "Thu nhập tháng này",
    prev_month_earnings: "Thu nhập tháng trước",
    design_submitted: "Đã gửi thiết kế",
    design_link_image_only: "Liên kết phải trỏ đến hình ảnh (.png, .jpg, .jpeg)",
    no_designs: "Không có thiết kế đang chờ",
    instructions: "Hướng dẫn",
    download_files: "Tải tệp",
    client_files: "TỆP KHÁCH HÀNG",
    revisions: "Sửa đổi",
    paste_design_link: "Dán liên kết thiết kế",
    send_design: "Gửi",
    design_sent: "Đã gửi thiết kế - đang chờ xác nhận",
    open_patterns_dropbox: "Mở Patterns trên Dropbox",
    design_requests_title: "Yêu cầu thiết kế",
    design_requests_desc: "Yêu cầu thiết kế cho câu lạc bộ",
    design_requests_nav: "Yêu cầu thiết kế",
    designs_nav: "Thiết kế",
    new_design_request: "Yêu cầu mới",
    club_name: "Tên câu lạc bộ",
    instructions_label: "Hướng dẫn cho designer",
    instructions_placeholder: "Mô tả thiết kế (màu sắc, logo, phong cách...)",
    instructions_auto_translate: "Hướng dẫn sẽ được dịch tự động sang tiếng Anh",
    files_link_label: "Liên kết tệp (logo, màu sắc...)",
    send_request: "Gửi yêu cầu",
    design_requested: "Đã gửi yêu cầu thiết kế",
    no_design_requests: "Không có yêu cầu thiết kế",
    view_design: "Xem thiết kế",
    revision_comment_placeholder: "Mô tả thay đổi cần thiết...",
    request_revision: "Yêu cầu sửa đổi",
    validate_design: "Xác nhận thiết kế vĩnh viễn",
    design_validated: "Đã xác nhận thiết kế",
    countdown_remaining: "Còn lại",
    countdown_late: "TRỄ",
    countdown_day_suffix: "ngày",
    revision_sent: "Đã yêu cầu sửa đổi",
    invoice_recap: "Tóm tắt hóa đơn",
    invoice_recap_nav: "Hóa đơn Designer",
    invoice_recap_desc: "Lịch sử thiết kế đã xác nhận và số tiền thanh toán",
    no_invoices: "Không có hóa đơn",
    year_earnings: "Thu nhập năm",
    pending_requests: "Yêu cầu đang chờ",
    treated_requests: "Yêu cầu đã xử lý",
    edit_design_request: "Chỉnh sửa yêu cầu",
    confirm_delete_design: "Xóa yêu cầu thiết kế này?",
    confirm_delete_revision: "Xóa yêu cầu sửa đổi này?",
    revision_deleted: "Đã xóa sửa đổi",
    design_deleted: "Đã xóa yêu cầu",
    design_updated: "Đã cập nhật yêu cầu",
    designer_archives_title: "LƯU TRỮ",
    validate_confirm_title: "XÁC NHẬN THIẾT KẾ CUỐI CÙNG",
    validate_confirm_message: "Bạn sắp xác nhận vĩnh viễn thiết kế cho \"{club}\".",
    validate_confirm_warning: "Hành động này không thể hoàn tác. Sau khi xác nhận, thiết kế sẽ được coi là hoàn thành và lập hóa đơn cho nhà thiết kế.",
    validate_definitive: "XÁC NHẬN CUỐI CÙNG",
    duplicate_club_title: "Không thể tạo yêu cầu",
    understood: "Đã hiểu",
    cancel: "Hủy",
    email_templates_desc: "Mẫu email sẵn sàng sử dụng cho việc tìm kiếm khách hàng và theo dõi",
    tpl_prospection: "Liên hệ đầu tiên",
    tpl_devis: "Gửi báo giá",
    tpl_relance_devis: "Nhắc lại báo giá",
    tpl_relance_contact: "Nhắc lại liên hệ",
    tpl_suivi_satisfaction: "Theo dõi sự hài lòng",
    tpl_fidelisation: "Khách hàng thân thiết / Mùa mới",
    email_subject: "Chủ đề",
    copy: "Sao chép",
    copied: "Đã sao chép!",

    orders_title: "Đơn hàng",
    new_order: "Đơn hàng mới",
    order_number: "Mã đơn hàng",
    search_client: "Tìm theo tên hoặc công ty...",
    add_client: "Khách hàng mới",
    firstname: "Tên",
    postal_code: "Mã bưu điện",
    city: "Thành phố",
    delivery_preview: "Xem trước ngày giao",
    order_lines: "Dòng đơn hàng",
    add_line: "Thêm dòng",
    product: "Sản phẩm",
    quantity: "Số lượng",
    unit_cost: "Giá gốc",
    weight_kg: "Trọng lượng (kg)",
    unit_price: "Đơn giá",
    subtotal: "Thành tiền",
    transport_estimate: "Ước tính vận chuyển",
    cost_per_kg: "Phí/kg",
    fixed_fee: "Phí cố định",
    total_weight: "Tổng trọng lượng",
    transport_cost: "Phí vận chuyển",
    selling_price_eur: "Giá bán EUR",
    selling_price_vnd: "Giá bán VND",
    profit: "LỢI NHUẬN",
    sale_minus_product: "Bán - Sản phẩm",
    sale_minus_all: "Bán - Sản phẩm - Vận chuyển",
    dropbox_link: "Link Dropbox",
    save_order: "Lưu đơn hàng",
    update_order: "Cập nhật",
    required_fields_missing: "Thiếu các trường bắt buộc",
    images: "Hình ảnh",
    add_image: "Thêm hình",
    upload_image: "Tải lên",

    // Tracking & Details
    track_package: "THEO DÕI BƯU KIỆN",
    add_tracking: "Thêm tracking",
    add_weight: "Thêm cân nặng",
    create_colis: "Tạo kiện hàng",
    select_at_least_2: "Chọn ít nhất 2 đơn để tạo kiện hàng",
    package: "Bưu kiện",

    // Transport Dashboard - Hóa đơn & Kiện hàng
    invoices_title: "Hóa đơn",
    uninvoiced_packages: "Kiện hàng chưa lập hóa đơn",
    create_invoice: "Tạo hóa đơn",
    invoices_list: "Hóa đơn",
    invoice_number: "Số",
    invoice_date: "Ngày",
    invoice_packages: "Kiện",
    invoice_weight: "Cân nặng",
    invoice_total: "Tổng VND",
    invoice_status: "Trạng thái",
    invoice_paid: "Đã thanh toán",
    invoice_pending: "Chờ thanh toán",
    no_invoices: "Không có hóa đơn",
    orders_label: "Đơn hàng",
    invoiced_label: "Đã lập HĐ",
    invoiced_yes: "Có",
    invoiced_no: "Chưa",
    colis_header: "KIỆN HÀNG",
    colis_orders_count: "đơn hàng",
    suivi: "Theo dõi",
    ignore: "Bỏ qua",
    colis_name: "Tên kiện hàng",
    piece_type: "Loại sản phẩm",
    estimated_weight: "Trọng lượng ước tính",
    tracking_link_label: "Link theo dõi bưu kiện",
    tracking_number_label: "Số bưu kiện",
    detail: "Chi tiết",
    tissu: "Vải",
    quantities: "Số lượng",
    quantities_detail: "Chi tiết số lượng",
    product_name: "Tên sản phẩm",

    clients_title: "Khách hàng",
    new_client: "Khách hàng mới",
    company_name: "Công ty",
    total_orders: "Đơn hàng",
    total_ca: "Tổng doanh thu",

    products_title: "Sản phẩm",
    new_product: "Sản phẩm mới",
    product_name: "Tên sản phẩm",
    cost: "Giá gốc",
    weight: "Trọng lượng",

    archives_title: "Lưu trữ",
    archives_subtitle: "Đơn hàng đã giao theo tháng",
    delivered_orders: "đơn đã giao",
    material_cost: "Giá nguyên liệu",
    transport_cost_label: "Phí vận chuyển",
    delivery_cost: "Phí giao hàng",

    commercials_title: "Nhân viên KD",
    commercials_subtitle: "Quản lý tài khoản và hoa hồng",
    new_commercial: "Nhân viên KD mới",
    zone: "Khu vực",
    commission_rate: "Tỷ lệ hoa hồng",
    weekly_recap: "Tổng kết tuần",
    weekly_recap_subtitle: "Tổng quan hiệu suất: doanh thu và hoa hồng",
    week_orders: "ĐH tuần",
    week_ca: "DT tuần",
    week_commission: "HH tuần",
    month_orders: "ĐH tháng",
    month_ca_label: "DT tháng",
    month_commission_label: "HH tháng",
    commissions_by_month: "Hoa hồng theo tháng / năm",
    commissions_by_month_subtitle: "Chi tiết hoa hồng tự động cho từng nhân viên KD",
    months_count: "tháng",

    partners_title: "Đối tác",
    partners_subtitle: "Quản lý quyền truy cập (In ấn, May, Vận chuyển, Quản lý)",
    new_partner: "Đối tác mới",
    partner_type: "Loại đối tác",
    allowed_statuses: "Trạng thái được phép",
    status_help: "Trạng thái 1 = đơn hàng hiển thị, các trạng thái sau = có thể áp dụng",

    expenses_title: "Chi phí",
    new_expense: "Chi phí mới",
    expense_type: "Loại",
    amount: "Số tiền",
    description: "Mô tả",
    currency: "Tiền tệ",

    transport_title: "Chi phí vận chuyển",
    transport_subtitle: "Quản lý chi phí theo quốc gia",
    add_country: "Thêm quốc gia",
    monthly_report: "Báo cáo tháng - Giao hàng",
    monthly_report_subtitle: "Số đơn hàng đã giao theo tháng",
    total_delivered: "đơn đã giao",
    delivered_count: "Đơn đã giao",

    settings_title: "Cài đặt",
    eur_vnd_rate: "Tỷ giá EUR/VND",

    partner_orders: "Đơn hàng cần xử lý",
    partner_orders_subtitle: "đang chờ xử lý",
    pending_orders: "đơn hàng chờ xử lý",
    no_pending_orders: "Không có đơn hàng chờ xử lý",
    validate: "XÁC NHẬN",
    weight_label: "Trọng lượng (kg)",
    address_delivery: "Địa chỉ giao hàng",
    partner_archives: "Lưu trữ - Công việc hoàn thành",
    partner_archives_subtitle: "đơn đã xử lý, theo tháng",
    delivery_expected: "Dự kiến giao",
    not_provided: "Chưa cung cấp",

    type_imprimeur: "In ấn",
    type_couture: "May",
    type_transport: "Vận chuyển",
    type_manager: "Quản lý",
    type_createur_fichiers: "Tạo tệp",
    type_checkin: "Checkin",

    manager_title: "Bảng điều khiển Quản lý",
    manager_subtitle: "Theo dõi đơn hàng đang xử lý",

    click_to_enlarge: "Nhấn để phóng to",
    no_image: "Không có hình",
    image_popup_title: "Hình ảnh đơn hàng",

    new_order_notification: "Đơn hàng mới!",
    new_orders_notification: "đơn hàng mới!",
    alert_orange_notification: "Cảnh báo: đơn hàng sắp đến hạn!",
    alert_red_notification: "Khẩn cấp: đơn hàng quá hạn!",

    estimated_profit: "LỢI NHUẬN ƯỚC TÍNH",
    product_cost_label: "Giá sản phẩm",
    product_lines: "dòng sản phẩm",

    filter_by_status: "Lọc theo trạng thái",
    filter_by_date: "Lọc theo ngày",
    filter_by_commercial: "Lọc theo NV kinh doanh",
    all_statuses: "Tất cả trạng thái",
    all_commercials: "Tất cả NV kinh doanh",
    from_date: "Từ",
    to_date: "Đến",
    reset_filters: "Đặt lại",
    order_list: "Danh sách đơn hàng",
    no_orders: "Không có đơn hàng",

    status_flow: "Luồng trạng thái",

    password: "Mật khẩu",
    name: "Tên",

    // Support v2
    ticket_title: "Tiêu đề",
    ticket_title_placeholder: "Tóm tắt yêu cầu của bạn...",
    active_tickets: "Yêu cầu đang hoạt động",
    archived_tickets: "Lưu trữ",
    archive: "Lưu trữ",
    unarchive: "Khôi phục",
    edit_response: "Sửa",
    no_archived_tickets: "Không có yêu cầu lưu trữ.",
    size_guide_images: "Hình ảnh hướng dẫn kích cỡ",
    size_guide_images_desc: "Quản lý hình ảnh hiển thị trong hướng dẫn kích cỡ (tối đa 4).",
    add_image_url: "Thêm hình",
    upload_file: "Tải lên tệp",
    image_added: "Đã thêm hình",
    image_removed: "Đã xóa hình",
    images_saved: "Đã lưu hình",
    max_images_reached: "Đã đạt tối đa 4 hình",
    alert_sounds_title: "Âm thanh cảnh báo",
    alert_sounds_desc: "Tải lên tệp âm thanh của bạn cho thông báo đơn hàng.",
    new_order_sound: "Âm thanh đơn hàng mới",
    status_change_sound: "Âm thanh thay đổi trạng thái",
    upload_audio: "Tải lên tệp âm thanh",
    sound_uploaded: "Tải âm thanh thành công",
    sounds_saved: "Đã lưu âm thanh",
    remove_sound: "Xóa âm thanh",
    play_sound: "Nghe",
    stop_sound: "Dừng",
    status_update_notification: "Trạng thái đã cập nhật!",
    current_month: "Tháng hiện tại",
    year: "Năm",
    // Premium client dashboard
    premium_title: "ĐỐI TÁC CAO CẤP PANTHER",
    premium_home: "Trang chủ",
    premium_archives: "Lưu trữ",
    premium_size_guide: "Hướng dẫn kích thước",
    premium_personalization: "Tùy chỉnh",
    premium_contact: "Liên hệ",
    premium_orders_active: "Đơn hàng đang xử lý",
    premium_orders_total: "Tổng đơn hàng",
    premium_delivery_address: "Địa chỉ giao hàng",
    premium_no_orders: "Không có đơn hàng đang xử lý",
    premium_order_archives: "Lưu trữ đơn hàng",
    premium_no_archives: "Không có đơn hàng đã giao",
    premium_contact_name: "MIRALLES Cédric",
    premium_contact_role: "Quản lý Panther",
    premium_whatsapp: "Liên hệ qua WhatsApp",
    premium_zalo: "Liên hệ qua Zalo",
    premium_social_title: "Theo dõi chúng tôi trên mạng xã hội",
    premium_payment_title: "Điều kiện thanh toán & Phí",
    premium_add_line: "Thêm dòng",
    premium_export_excel: "Xuất Excel",
    premium_exporting: "Đang xuất...",
    premium_logout: "Đăng xuất",
    premium_client_space: "Không gian Cao cấp",
    // Production stats
    prod_this_year: "Năm nay, PANTHER đã sản xuất",
    prod_pieces: "sản phẩm",
    prod_warning: "Hãy tuân thủ thời hạn sản xuất. Các đơn hàng trễ sẽ bị phạt, vì vậy đừng quên xác nhận trạng thái của từng đơn hàng đúng thời hạn. Cảm ơn.",
    prod_late_title: "Tháng này, bạn có",
    prod_late_suffix: "đơn hàng trễ!",
    prod_late_see: "Xem đơn hàng trễ",
    prod_late_order: "Đơn hàng",
    prod_late_deadline: "Hạn giao couture",
    prod_late_changed: "Ngày thay đổi trạng thái",
    prod_late_days: "ngày trễ",
    prod_late_still: "Đang chờ",
  }
};

// Helper: translate a status string
export const translateStatus = (status, t) => {
  const key = `status_${status}`;
  const translated = t(key);
  return translated !== key ? translated : status.toUpperCase();
};

// Helper: translate urgency
export const translateUrgency = (urgency, t) => {
  const map = { 'urgent': 'urgency_urgent', 'prioritaire': 'urgency_prioritaire', 'classique': 'urgency_classique', 'non urgent': 'urgency_non_urgent' };
  const key = map[urgency];
  return key ? t(key) : urgency;
};

// Helper: translate partner type
export const translatePartnerType = (type, t) => {
  const key = `type_${type}`;
  const translated = t(key);
  return translated !== key ? translated : type;
};

export default translations;
